import React from 'react';
import PropTypes from 'prop-types';
import { Tabs } from 'antd';
import styled from 'styled-components';
import { autobind } from 'core-decorators';
import BaseComponent from 'components/BaseComponent';
import styledComp, { FlexColContainer, FlexRowContainer, translateThemeConsts } from 'components/StyledComp';
import ChangeHistoriesButton from 'components-desktop/histories/ChangeHistoriesButton';

const propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),

  color: PropTypes.string,
  title: PropTypes.string,
  icon: PropTypes.string,
  tabs: PropTypes.array,

  // If set, these two props will make the Panel a controlled component.
  tabsActiveKey: PropTypes.string,
  tabsOnChange: PropTypes.func,

  changeHistoryTable: PropTypes.string,
  changeHistoryRowId: PropTypes.number,
};

const defaultProps = {
  color: '#000000',
  title: '',
  icon: '',
  tabs: null,
};

const StyledTabs = styled(Tabs)`
  width: 100%;
  margin-top: -40px;

  .ant-tabs-bar {
    margin-bottom: 0;
    border-bottom: 0;

    .ant-tabs-nav-container {
      .ant-tabs-nav-scroll {
        text-align: right;
        
        .ant-tabs-nav {
          // div[role=tab] {
          //  border-bottom-width: 0;
          //}
  
          div[aria-selected=false] {
            background-color: ${props => translateThemeConsts(props.color, props)};
            border-color: ${props => translateThemeConsts(props.color, props)};
            color: #ffffff;
          }
          
          div[aria-selected=true] {
            color: #000000;
          }
        }
      }
    }
  }
`;

@autobind
class Panel extends BaseComponent {
  constructor(props) {
    super(props);
  }

  renderContent() {
    const {
      children,
      color,
      title,
      icon,
      tabs,
      tabsActiveKey,
      tabsOnChange,
      changeHistoryTable,
      changeHistoryRowId,
      ...layoutProps
    } = this.props;

    return (
      <FlexColContainer
        {...layoutProps}
        alignItems="center"
        border={`1px solid ${color}`}
        borderRadius="2px"
      >
        <FlexRowContainer
          width="match_parent"
          height="wrap_content"
          padding="8px 8px"
          justifyContent="space-between"
          alignItems="center"
          backgroundColor={color}
        >
          <FlexRowContainer
            width="wrap_content"
            height="wrap_content"
            alignItems="center"
          >
            {icon &&
              <styledComp.AntdIcon
                width="wrap_content"
                height="wrap_content"
                margin="0 8px 0 4px"
                color="textPrimaryLight"
                fontSize="14px"
                type={icon}
              />
            }

            <styledComp.Span
              width="wrap_content"
              height="wrap_content"
              color="textPrimaryLight"
              fontSize="18px"
            >
              {title}
            </styledComp.Span>
          </FlexRowContainer>

          {changeHistoryTable && changeHistoryRowId &&
            <ChangeHistoriesButton
              width="wrap_content"
              height="wrap_content"
              margin="0 8px 0 0"
              table={changeHistoryTable}
              rowId={changeHistoryRowId}
            />
          }
        </FlexRowContainer>

        <FlexColContainer
          width="match_parent"
          height="wrap_content"
          alignItems="center"
        >
          {(tabs && tabs.length > 0) &&
            <StyledTabs
              color={color}
              type="card"
              activeKey={tabsActiveKey ? `.$${tabsActiveKey}` : undefined}
              onChange={tabsOnChange}
            >
              {React.Children.map(children, (child, i) => (
                <Tabs.TabPane key={child.key} tab={tabs[i]}>
                  {child}
                </Tabs.TabPane>
              ))}
            </StyledTabs>
          }

          {(!tabs || tabs.length === 0) &&
            children
          }
        </FlexColContainer>
      </FlexColContainer>
    );
  }
}

// https://facebook.github.io/react/docs/typechecking-with-proptypes.html
Panel.propTypes = propTypes;
Panel.defaultProps = defaultProps;

export default Panel;
